import checkIsTicketTypeVisible from './checkIsTicketTypeVisible';

export default function getVisibleTicketTypes(ticketGroup, query = {}) {
  const visibleTicketTypes = ticketGroup.ticketTypes.filter(ticketType =>
    checkIsTicketTypeVisible(ticketType, query),
  );

  return visibleTicketTypes;
}
